import { useEffect, useState } from 'react';
import { Dynamics } from '../services/dynamics/dynamics';
import { DynamicsV2 } from '../services/dynamics/dynamics-v2';
import { EModeValue } from '../services/dynamics/enums/mode.enum';
import { ESessionTemplate } from '../services/dynamics/enums/v2/session-template.enum';

export const useSessions = () => {
  const [dynVersion, setDynVersion] = useState<1 | 2>(null);

  useEffect(() => {
    if (
      !dynVersion ||
      dynVersion === 1 ||
      DynamicsV2.isAlreadyExist('HOME_PAGE')
    ) {
      return;
    }

    DynamicsV2.createSession(
      {
        templateName: ESessionTemplate.HOME,
        templateParameters: {},
      },
      {
        id: 'HOME_PAGE',
        navigateTo: null,
      },
    ).then(() => Dynamics.setMode(EModeValue.DOCK));
  }, [dynVersion]);

  return {
    dynVersion,
    setDynVersion,
  };
};
